import { Checkbox } from "components/ui/Checkbox";
import { connectToggleRefinement } from "react-instantsearch-dom";

interface ConnectedToggleProps {
  id: string;
  name: string;
  className: string;
  label: string;
  currentRefinement: boolean;
  refine: (nextRefinement: boolean) => boolean;
}

function ConnectedToggle({ id, name, className, label, currentRefinement, refine }: ConnectedToggleProps) {
  return (
    <Checkbox
      id={id}
      name={label || name}
      className={className}
      checked={currentRefinement}
      onCheckedChange={(checked) => refine(checked === true)}
    />
  );
}

export default connectToggleRefinement(ConnectedToggle);
